import React from 'react';
import NextImage from 'next/image';

import type { ImageProps } from 'Elements/Image';

import Grid, { Col } from 'Components/Grid';

import Inner, { WaveHeroInnerProps } from '../subcomponents/Inner';
import GraduateStoriesInner, {
    GraduateStoriesInnerProps
} from '../subcomponents/GraduateStoriesInner';

import { Wave, WaveGrey } from 'Modules/HeroBanner/MakeWaves/MakeWaves.styled';
import { Container, ImageWrapper } from './Image.styled';

export interface Props {
    inner?: WaveHeroInnerProps | GraduateStoriesInnerProps;
    image?: ImageProps;
    imageQuality?: number;
    backgroundColour?: string;
    textColour?: string;
    showWave?: boolean;
    children?: React.ReactNode;
}

const Image: React.FC<Props> = props => {
    const {
        inner,
        image,
        imageQuality = 75,
        backgroundColour,
        textColour,
        showWave = true,
        children
    } = props;

    return (
        <Container
            style={
                {
                    '--hero-bg-colour': backgroundColour,
                    '--hero-txt-colour': textColour
                } as React.CSSProperties
            }
        >
            {showWave &&
                (backgroundColour && backgroundColour === '#FFFFFF' ? <WaveGrey /> : <Wave />)}
            <Grid layout="fill" style={{ flex: 1 }}>
                <Col b={11} m={5}>
                    {inner && 'heading' in inner && !('videoCaption' in inner) ? (
                        <Inner {...inner} />
                    ) : inner && 'videoCaption' in inner ? (
                        <GraduateStoriesInner {...inner} />
                    ) : (
                        children
                    )}
                </Col>
            </Grid>
            {image && (
                <ImageWrapper>
                    <NextImage
                        src={image.src}
                        alt=""
                        fill
                        style={{ objectFit: 'cover', objectPosition: 'center' }}
                        quality={imageQuality}
                        priority
                        loading="eager"
                    />
                </ImageWrapper>
            )}
        </Container>
    );
};

export default Image;
